import { useEffect } from "react";
import { useGrowthBook } from "@growthbook/growthbook-react";
import DataLayerHelper from "../../../helpers/tagManager/DataLayerHelper";


const VambeWebchatController = () => {
  const growthbook = useGrowthBook();
  const isVambeEnabled = growthbook.getFeatureValue("commercial-chatbot-data-vambe", false);
  const embeddedWebchatConfig = {
    clientId: "617fc904-76d2-4017-85f3-13bf24b105b3",
    channelId: "3de09848-0d21-429c-bfa4-64c25a21f688",
    agentName: "Asistente Autofact",
    agentIconUrl: "https://autofacttrf.zendesk.com/embeddable/avatars/34165793979789",
    primaryColor: "#014dc6",
    language: "es",
    chatWithUsText: "¡Hola!  ¿Tienes dudas sobre la transferencia?",
    yPosition: 65
  }
  function handleOpenButtonClick () {
    DataLayerHelper.pushEvent('select_content', {content_type: 'commercial-chatbot-data-vambe', content_id: 'commercial-chatbot-data-vambe-open'})
  }
  function handleSentApiMessage () {
    DataLayerHelper.pushEvent('select_content', {content_type: 'commercial-chatbot-data-vambe', content_id: 'commercial-chatbot-data-vambe-sent'})
  }

  const observeOpenButtonClick = () => new MutationObserver(()=>{
    const webchatEl = document.getElementById('webchat-container');
    if (webchatEl) {
        const openButtonEl = webchatEl.querySelector('button');
        if (openButtonEl) {
            openButtonEl.addEventListener('click', handleOpenButtonClick);
        }
    }
  }).observe(document.documentElement,{childList:true,subtree:true});

  const observeSentApiMessage = () => {
    const originalFetch = window.fetch;
    const targetUrl = 'https://api.vambe.ai/frontend/api/webchat/message/send-inbound';
    const targetMethod = 'POST';

    window.fetch = async function(input: RequestInfo | URL, init?: RequestInit) {
        let url: string;
        if (input instanceof Request){
          url = input.url;
        } else if (input instanceof URL) {
          url = input.toString();
        } else {
          url = input;
        }

        const method = init?.method ? init.method.toUpperCase() : 'GET';
        if (url === targetUrl && method === targetMethod) {
            handleSentApiMessage()
        }
        return originalFetch(input, init);
    };
  }
  

  useEffect(() => {
      if (isVambeEnabled) {
        // @ts-ignore
        window.embeddedWebchatConfig = embeddedWebchatConfig;
        const script = document.createElement('script');
        script.src = "https://vambeai.com/webchat.js"
        script.onload = () => { 
          observeOpenButtonClick()
          observeSentApiMessage()
        }
        document.head.appendChild(script);
        return () => {
          document.head.removeChild(script);
        }
      };
  }, [isVambeEnabled]);

  return null;
};

export default VambeWebchatController;
